import React from 'react';
import { Box } from 'vindi-ds-components';

function CardLinks({ children }) {
  return (
    <Box display='flex' flexDirection='row' alignItems='center'>
      {children}
    </Box>
  );
}

export default CardLinks;
